<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              <b>Boletos Avulsos</b>
            </h3>
            <router-link tag="a" class="btn btn-primary pull-right" to="/financeiro/boletos-avulsos/novo">Novo</router-link>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-md-10">
                <input
                  style="width: 100%"
                  class="form-control"
                  placeholder="Busca: Entre com o NOME ou DOCUMENTO do cliente e pressione enter"
                  name="filtro_pesquisa"
                  ref="filtro_pesquisa"
                  type="text"
                  v-model="dados.pesquisa"
                  @keyup.enter="getDataTable"
                />
              </div>
              <div class="col-md-2">
                <button @click="getDataTable" class="btn btn-default btn-block"><i class="fa fa-filter"></i> Filtrar</button>
              </div>
            </div>
            <div class="row" style="margin-top:15px">
              <div class="col-sm-12 table-responsive">
                <table
                  aria-describedby="example1_info"
                  role="grid"
                  id="example1"
                  class="table table-bordered table-striped"
                >
                  <thead>
                    <tr role="row">
                      <th style="width: 10%">ID</th>
                      <th style="width: 16%">Cliente</th>
                      <th style="width: 12%">CPF/CNPJ</th>
                      <th style="width: 10%">Vencimento</th>
                      <th style="width: 11%">Valor</th>
                      <th style="width: 8%">Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="even" role="row" v-for="item in apiData.data" :key="item.id">
                      <td>{{ item.id }}</td>
                      <td>{{ item.nome_razao }}</td>
                      <td>{{ item.cpf_cnpj }}</td>
                      <td>{{ item.vencimento | dataFormatada }}</td>
                      <td>{{ item.valor | numberFormat(2, ',', '.') }}</td>
                      <td>
                      <a
                          class="btn btn-warning btn-sm"
                          :href="`${$store.state.s3URI}/nova_garantia/remessas_avulsas/remessa_${item.created_at}-${item.id}.txt`"
                          target="_blank"
                          download
                          title="Download"
                        >
                          <i style="font-size:12px" class="fa fa-fw fa-download"></i>
                        </a>
                       	<button class="btn btn-info btn-sm" @click="getBoletoAvulso(item.id)" title="Gerar Boleto">
												<i class="fa fa-fw fa-barcode"></i>
											</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="row">
                  <div
                    class="col-sm-5"
                  >Mostrando {{ this.apiData.from }} até {{ this.apiData.to }} de {{ this.apiData.total }} registros encontrados.</div>
                  <div class="col-sm-7" style="text-align:right">
                    <laravue-pagination :limit="5" :data="apiData" v-on:pagination-change-page="getDataTable">
                      <span slot="prev-nav">&lt; Anterior</span>
                      <span slot="next-nav">Próximo &gt;</span>
                    </laravue-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.box-body -->
        </div>
        <!-- /.box -->
      </div>
      <!-- /.col-md-12 -->
    </div>
    <!-- /.row -->
  </section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http
import vSelect from "vue-select";
export default {
  data: () => ({
    empresas: [],
    empresaSelecionada: null,
    dados: {
      pesquisa: "",
      situacao: '',
      empresa_id: ''
    },
    apiData: {
      data: []
    }
  }),
  mounted() {
    this.getDataTable();
    this.$nextTick(() => {
      this.$refs.filtro_pesquisa.focus();
    });
  },

  methods: {
    getDataTable(page) {
      if (typeof page === "undefined") {
        page = 1;
      }
      this.dados.page = page;
      let config = this.$store.getters.getHeaderAuth;
      config.params = this.dados;
      axios
        .get(`${this.$store.state.serverURI}/api/boletoAvulso/getAllPaginate`, config)
        .then(response => {
          this.apiData = response.data;
        })
        .catch(error => {
          this.$store.commit("throwException", error);
        });
    },
     getBoletoAvulso(boletoId) {
      window.open(`${this.$store.state.serverURI}/api/boletoAvulso/getBoleto/${boletoId}`, '_blank');
    }
  },
  watch: {
    page: function(val) {
      this.getDataTable();
    },
     empresaSelecionada: function(val) {
       if (val) {
         this.dados.empresa_id = val.value;
       } else {
         this.dados.empresa_id = '';
       }
        
    }
  },

  components: {
    vSelect
  }
};
</script>
<style>
td {
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// index.vue?88ac45f0